import { createModel } from '@/store/tools';

const model = {
    namespace: 'picturenickname',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getPicturenicknames': T('getPicturenicknames'),
            'getStateEnum': T('getStateEnum'),
            'getTypeEnum': T('getTypeEnum'),
            'getIdentityEnum': T('getIdentityEnum'),
            'getPicturenicknameInfo': T('getPicturenicknameInfo'),
        },
        actions: {
            'getPicturenicknames': A('getPicturenicknames'),
            'getStateEnum': A('getStateEnum'),
            'getTypeEnum': A('getTypeEnum'),
            'getIdentityEnum': A('getIdentityEnum'),
            'getPicturenicknameInfo': A('getPicturenicknameInfo'),
        },
        sagas: {
            'getPicturenicknames': S('getPicturenicknames', '/?cmd=com.xqxc.api.pig.mis.biz.account.AvatarNicknameAuditMisService.list'),
            'getStateEnum': S('getStateEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getTypeEnum': S('getTypeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getIdentityEnum': S('getIdentityEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getPicturenicknameInfo': S('getPicturenicknameInfo', '/?cmd=com.xqxc.api.pig.mis.biz.account.AvatarNicknameAuditMisService.detail'),
        },
        reducers: {
            'picturenicknames': R('getPicturenicknames', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'stateEnum': R('getStateEnum', []),
            'typeEnum': R('getTypeEnum', []),
            'identityEnum': R('getIdentityEnum', []),
            'picturenicknameInfo': R('getPicturenicknameInfo', {}),
        }
    })
};
export default createModel(model);